/**
 * Some real, historical digicampusbd data has the literal text "undefined"
 * stored in place of a genuinely-blank optional field — confirmed live: 78%
 * of all non-empty `student_basic.registration_no` values in this database
 * are the literal string "undefined", not a real registration number (an old
 * app client-side bug that stringified a missing value before submitting,
 * not a migration artifact — the same garbage would show if the old app
 * displayed this field raw). A plain `value || fallback` doesn't catch this,
 * since the literal string is truthy. Use this wherever a value that might
 * carry this exact historical contamination is displayed or pre-filled.
 */
export function cleanText(value, fallback = "") {
  if (value === null || value === undefined) return fallback;
  const trimmed = String(value).trim();
  if (trimmed === "" || trimmed === "undefined" || trimmed === "null") return fallback;
  return value;
}
